import type React from "react";
import { Input } from "src/components/ui/input";
import { Label } from "src/components/ui/label";
import { sanitizeBrlValue } from "src/utils/functions";

interface RentalStepFormProps {
  valorAluguel: string;
  setValorAluguel: (v: string) => void;
  valorizacao: string;
  setValorizacao: (v: string) => void;
  igpm: string;
  setIgpm: (v: string) => void;
  rentabilidade: string;
  setRentabilidade: (v: string) => void;
}

export const RentalStepForm: React.FC<RentalStepFormProps> = ({
  valorAluguel,
  setValorAluguel,
  valorizacao,
  setValorizacao,
  igpm,
  setIgpm,
  rentabilidade,
  setRentabilidade,
}) => {
  return (
    <div className="grid md:grid-cols-2 gap-6 animate-in fade-in slide-in-from-right-4 duration-300">
      <div className="grid gap-2">
        <Label htmlFor="valorAluguel">Valor do aluguel (R$)</Label>
        <div className="relative">
          <Input
            id="valorAluguel"
            type="text"
            placeholder="2.000,00"
            value={valorAluguel}
            onChange={(e) => setValorAluguel(sanitizeBrlValue(e))}
          />
        </div>
      </div>
      <div className="grid gap-2">
        <Label htmlFor="valorizacao">Valorização anual (%)</Label>
        <div className="relative">
          <Input
            id="valorizacao"
            type="text"
            placeholder="4,00"
            className="pr-8"
            value={valorizacao}
            onChange={(e) => setValorizacao(sanitizeBrlValue(e))}
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">
            %
          </span>
        </div>
      </div>
      <div className="grid gap-2">
        <Label htmlFor="igpm">IGPM anual (%)</Label>
        <div className="relative">
          <Input
            id="igpm"
            type="text"
            placeholder="8,63"
            className="pr-8"
            value={igpm}
            onChange={(e) => setIgpm(sanitizeBrlValue(e))}
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">
            %
          </span>
        </div>
      </div>
      <div className="grid gap-2">
        <Label htmlFor="rentabilidade">Rentabilidade anual (%)</Label>
        <div className="relative">
          <Input
            id="rentabilidade"
            type="text"
            placeholder="11,00"
            className="pr-8"
            value={rentabilidade}
            onChange={(e) => setRentabilidade(sanitizeBrlValue(e))}
          />
          <span className="absolute right-3 top-1/2 -translate-y-1/2 text-gray-500">
            %
          </span>
        </div>
      </div>
    </div>
  );
};
